import { productStockManagementActions } from "./ProductStockManagementReducer";
import { useProductAPI  } from '../../../api/product/useProductAPI';

export const useProductStockManageMent = () => {
    const api = useProductAPI();
  
    const request = {
        get: (params) => {
          return async (dispatch) => {
            try {
              const response = await api.productStockManagement.get(params);
              dispatch(productStockManagementActions.funGetProductStockManagement(response));
            } catch (error) {
              console.error('Error fetching data:', error);
            }
          }
        },
        post: async (data) => {
          return await api.product.post(data);
        },
        put: async (data) => {
          return await api.product.put(data);
        },
        delete: async (params) => {
          return await api.product.delete(params);
        }
    };
    return { request };
  };